import Breadcrumbs from '../../coreComponents/breadcrumbs';
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import CommonCardHeader from '../../coreComponents/CommonCardHeader';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { getAllFeedBacks } from '../../services/api';
import AjaxSourcedData from '../formsAndTable/tables/dataTables/dataSource/AjaxSourcedData';
import { getFeedbackTableColumns } from '../../data/formsAndTable/tables/dataTables/DataSource';
import { NoDataComponent } from '../formsAndTable/forms/formControls/NoDataComponent';

const FeedBacks = () => {
  const { t } = useTranslation();
  const [feedbacks, setFeedbacks] = useState(null);
  useEffect(() => {
    const fetchAllFeedbacks = async () => {
      const res = await getAllFeedBacks();
      if (res) {
        setFeedbacks(res);
      }
    };
    fetchAllFeedbacks();
  }, []);
  return (
    <>
      <Breadcrumbs
        mainTitle={t('feedback.feebBacksPageTitle')}
        // parent={t('courses.generalTitle')}
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={t('feedback.feedBacksTableTitle')} tag />
              <CardBody>
                {feedbacks && (
                  <AjaxSourcedData
                    data={feedbacks}
                    columns={getFeedbackTableColumns(t)}
                    noDataComponent={<NoDataComponent />}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default FeedBacks;
